import { Inverter } from "ngx-core-services";

export const sumDailyEnergies = (energies: Partial<Inverter>[]): Partial<Inverter> => energies.reduce((prev, curr) =>({
  EG1: `${(Number(prev.EG1) || 0) + (Number(curr.EG1) || 0)}`,
  EG2: `${(Number(prev.EG2) || 0) + (Number(curr.EG2) || 0)}`,
  EG3: `${(Number(prev.EG3) || 0) + (Number(curr.EG3) || 0)}`,
  EG4: `${(Number(prev.EG4) || 0) + (Number(curr.EG4) || 0)}`,
  EG5: `${(Number(prev.EG5) || 0) + (Number(curr.EG5) || 0)}`,
  EG6: `${(Number(prev.EG6) || 0) + (Number(curr.EG6) || 0)}`,
  SOL_EG: `${(Number((prev as any).SOL_EG) || 0) + (Number((curr as any).SOL_EG) || 0)}`,
}), {} as Partial<Inverter>);

export const getStackedEnergySeries = (seriesName: string): string => {
  switch (seriesName) {
    case 'EG1':
      return 'generated';
    case 'EG2':
      return 'exchanged';
    case 'EG3':
      return 'exchanged';
    case 'EG4':
      return 'consumed';
    case 'EG5':
      return 'battery';
    case 'EG6':
      return 'battery';
    default:
      return 'unknown';
  }
};
